import { FC } from 'react';
import Layout from '@/components/layout/Layout';
import BookCardItem from '@/components/ui/book-card-item/BookCardItem';
import Pagination from '@/components/ui/pagination/Pagination';
import Breadcrumbs from '@/components/ui/breadcrumbs/Breadcrumbs';
import SectionTitle from '@/components/ui/section-title/SectionTitle';
import SeriesJsonMarkup from './series-json-markup/SeriesJsonMarkup';
import { useGetUrlPath } from '@/hooks/useGetUrlPath';
import { ISeriesBooksPage, ISeriesBooksList } from '@/interfaces/seriesBooksPage.interface';
import { IWidgetsSideBar } from '@/interfaces/widgets.interface';
import { BOOKS_FOR_PAGE } from '@/helpers/variables';

interface ISeriesBooksPageProps extends IWidgetsSideBar {
  books: ISeriesBooksPage;
}

const SeriesDetail: FC<ISeriesBooksPageProps> = ({ books, todayWidget, popularBooksWidget }) => {
  const seriesBooks = books.data[0].books_list;
  const seriesTitle = books.data[0].title;
  const seriesAlias = books.data[0].title_translit;

  const pagesCount = Math.ceil(books.data[0].book_count / BOOKS_FOR_PAGE);

  //Seo block
  const SEO_TITLE = `Книги серии «${seriesTitle}» - скачать бесплатно в fb2 или читать онлайн`;
  const SEO_DESCRIPTION = `Книги серии «${seriesTitle}» в библиотеке BookZ. ✔️ Скачать бесплатно в формате fb2, epub, pdf. ✔️ Читать онлайн на сайте.`;
  const SEO_CANONICAL = `/seria-knig/${books.data[0].title_translit}`;

  return (
    <Layout
      title={SEO_TITLE}
      description={SEO_DESCRIPTION}
      canonicalHref={SEO_CANONICAL}
      pageHref={useGetUrlPath()}
      breadcrumbs={<Breadcrumbs firstPageName="Серии книг" firstPageAlias="/serii-knig/" secondPageName={seriesTitle} />}
      todayWidget={todayWidget}
      popularBooksWidget={popularBooksWidget}
    >
      <SeriesJsonMarkup data={books} />
      <SectionTitle name={`Книги серии ${seriesTitle}`} />
      <div>{seriesBooks.length > 0 ? seriesBooks.map((book: ISeriesBooksList) => <BookCardItem book={book as any} key={book.id} />) : <div>Книги не найдены</div>}</div>
      <Pagination pagesCount={pagesCount ?? 0} postName={`seria-knig/${seriesAlias}/page=`} />
    </Layout>
  );
};

export default SeriesDetail;
